import * as React from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

const marks = [
    {
        value: 0,
        label: '0°C',
    },
    {
        value: 20,
        label: '20°C',
    },
    {
        value: 40,
        label: '40°C',
    },
    {
        value: 60,
        label: '40°C',
    },
    {
        value: 80,
        label: '40°C',
    },
    {
        value: 100,
        label: '100°C',
    },
];

function valuetext(value: number) {
    return `${value}°C`;
}

export default function DiscreteSliderLabel({Title} : {Title: string}) {
    return (
        <Box sx={{ width: 300, m: 2 }}>
            <h2>{Title}</h2>
            <Slider
                aria-label="Always visible"
                defaultValue={80}
                getAriaValueText={valuetext}
                step={10}
                marks={marks}
                valueLabelDisplay="on"
            />
        </Box>
    );
}